import { render, staticRenderFns } from "./noticePage.vue?vue&type=template&id=b8775736&"
import script from "./noticePage.vue?vue&type=script&lang=js&"
export * from "./noticePage.vue?vue&type=script&lang=js&"
import style0 from "./noticePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports